import { Text } from '@chakra-ui/react';

const ListHeader = ({ children }) => {
  return (
    <Text fontWeight="600" fontSize="sm" mb={2}>
      {children}
    </Text>
  );
};

export default ListHeader;
